import * as React from "react";
import {
  Button,
  Typography,
  Grid,
  ToggleButtonGroup,
  TextField,
  ToggleButton,
  AppBar,
  Box,
  Toolbar,
  Stack,
  Snackbar,
  Alert,
  IconButton,
} from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import CloseIcon from "@mui/icons-material/Close";
import SetupDialog from "./SetupDialog";

/* global console */

export interface WelcomeProps {
  title: string;
  logo: string;
  message: string;
  loginurl: (x: string) => void;
  login: () => {};
}

interface WelcomeState {
  textvalue: string;
  selbutton: string;
  showfield: boolean;
  showdialog: boolean;
  messagecaption: string;
  popupopen: boolean;
  opendlg: boolean;
  value: {};
}

export default class Welcome extends React.Component<WelcomeProps, WelcomeState> {
  constructor(props, context) {
    super(props, context);
    this.state = {
      textvalue: "",
      selbutton: "Production",
      showfield: false,
      showdialog: false,
      messagecaption: "",
      popupopen: false,
      opendlg: false,
      value: {},
    };
    this.props.loginurl("Production");
    this.boundSetState = this.setState.bind(this);
    this.displayError = this.displayError.bind(this);
    this.handleClosedlg = this.handleClosedlg.bind(this);
    //this.processsignupMessage = this.processsignupMessage.bind(this);
  }
  boundSetState: () => {};
  displayError = (error: string) => {
    this.setState({ messagecaption: error });
    this.setState({ popupopen: true });
  };
  handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ popupopen: false });
  };
  handleClosedlg = (newValue?: any) => {
    console.log("newValue");
    console.log(newValue);
    this.setState({ value: newValue });
    this.setState({ opendlg: false });
    //this.processsignupMessage(newValue);
  };

  render() {
    const { login, loginurl } = this.props;

    const showdialogofsignup = () => {
      this.setState({ opendlg: true });
    };

    const handleInputChange = (e) => {
      this.setState({ textvalue: e.target.value });
      loginurl(e.target.value);
    };

    const handleChange = (e) => {
      this.setState({ selbutton: e.target.value });
      this.setState({ showfield: false });
      loginurl(e.target.value + "");
      if (e.target.value === "Custom") {
        this.setState({ showfield: true });
      }
    };

    return (
      <React.Fragment>
        <section className="ms-welcome__header">
          <img alt="Accordor" src="../components/../../../assets/logo-filled.png" width={150} />
        </section>
        <Box sx={{ alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "column" }}>
          <Snackbar open={this.state.popupopen} onClose={this.handleClose}>
            <Alert
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    this.handleClose();
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              severity="success"
              sx={{ width: "100%" }}
            >
              {this.state.messagecaption}
            </Alert>
          </Snackbar>
          <div>
            <Typography
              variant="h6"
              sx={{ padding: 1, fontSize: 16, fontWeight: "bold", fontStyle: "italic", marginBottom: 2 }}
            >
              Welcome to Template AI Designer!
            </Typography>
          </div>
          <div>
            <Typography sx={{ textAlign: "center", fontSize: 16, padding: 1 }}>
              Salesforce CLM Templates with AI powered to easy design, streamline, automate expertise to more efficiency
              without any code or knowledge.
            </Typography>
          </div>
          <div>
            <Stack direction="row" spacing={0}>
              <Typography sx={{ textAlign: "center", fontSize: 14, padding: 1 }}>Don&apos;t have a license?</Typography>
              <Button variant="text" onClick={showdialogofsignup}>
                Sign Up
              </Button>
            </Stack>
          </div>
        </Box>
        <AppBar position="fixed" color="inherit" sx={{ top: "auto", bottom: 0 }}>
          <Grid
            container
            rowSpacing={1}
            sx={{ height: "auto", padding: 0, width: "100%" }}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12}>
              <ToggleButtonGroup
                aria-label="Platform"
                sx={{ height: 30, marginBottom: 2, marginTop: 1, fontFamily: "Arial" }}
                onChange={handleChange}
              >
                <ToggleButton
                  selected={this.state.selbutton === "Production"}
                  value="Production"
                  sx={{
                    "&.MuiToggleButton-root.Mui-selected": {
                      backgroundColor: "#1C39BB",
                      color: "white",
                      fontFamily: "Arial",
                    },
                    textTransform: "none",
                    fontFamily: "Arial",
                  }}
                >
                  Production
                </ToggleButton>
                <ToggleButton
                  value="Sandbox"
                  selected={this.state.selbutton === "Sandbox"}
                  sx={{
                    "&.MuiToggleButton-root.Mui-selected": {
                      backgroundColor: "#1C39BB",
                      color: "white",
                      fontFamily: "Arial",
                    },
                    textTransform: "none",
                    fontFamily: "Arial",
                  }}
                >
                  Sandbox
                </ToggleButton>
                <ToggleButton
                  value="Custom"
                  selected={this.state.selbutton === "Custom"}
                  sx={{
                    "&.MuiToggleButton-root.Mui-selected": {
                      backgroundColor: "#1C39BB",
                      color: "white",
                      fontFamily: "Arial",
                    },
                    textTransform: "none",
                    fontFamily: "Arial",
                  }}
                >
                  Custom
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>
            <Grid item xs={12}>
              {this.state.showfield && (
                <Box sx={{ padding: 0, marginBottom: 2 }}>
                  <TextField
                    label="Enter custom sandbox URL"
                    name="custombox"
                    size="small"
                    id="customsandbox"
                    variant="standard"
                    value={this.state.textvalue}
                    onChange={handleInputChange}
                    InputProps={{
                      style: { fontSize: 14, minWidth: 270 },
                    }}
                    sx={{ width: "100%" }}
                  />
                </Box>
              )}
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={login}
                size="small"
                startIcon={<LoginIcon />}
                sx={{ color: "white", width: "100%", textTransform: "none", bgcolor: "#1C39BB" }}
              >
                <Typography sx={{ fontSize: 14 }}>LogIn to Salesforce...</Typography>
              </Button>
            </Grid>
          </Grid>
        </AppBar>
        <Toolbar />
        <SetupDialog
          keepMounted
          id="selsetdlg"
          open={this.state.opendlg}
          onClose={this.handleClosedlg}
          value={this.state.value}
        />
      </React.Fragment>
    );
  }
}
